import React, { FC, memo, useCallback } from 'react'

import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import { Container, SliderContainer } from './styles'
import GridCard from '../../common/grid-card'
import { CtaButtonText, CtaContainer, StyledGhostButton, Subtitle, Title, TitleContainer } from '../common/styles'
import { useTranslation } from '../../../hooks/locale'
import { Slide } from 'pure-react-carousel'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { Offer } from '../../../models/common/offers-model'
import { SuitablesModel } from '../../../models/common/suitables-model'
import { useResponsiveCards } from '../../../hooks/responsive'
import { StyledCarouselProvider, StyledSlider } from '../../common/listing-card-section/styles'
import { cardEventCategories, pageTypeEventCategories } from '../../../services/analytics-service/categories'

interface Props {
    topOfferListingsSection: ListingSectionTransport
    url: string
    sitePathname?: string
    breadcrumbModel: BreadcrumbListTransport
    offerModel: Offer
    suitablesModel: SuitablesModel
}

const TopOffersSection: FC<Props> = ({
    topOfferListingsSection,
    url,
    sitePathname,
    breadcrumbModel,
    offerModel,
    suitablesModel,
}) => {
    const { t } = useTranslation()

    const _handleViewAllAccommodationsClick = useCallback(() => {
        document.location.href = topOfferListingsSection.cta?.url || url
    }, [topOfferListingsSection.cta?.url, url])

    const topOfferListings = topOfferListingsSection.objects

    const visibleSlides = useResponsiveCards()
    const dragStep = Math.floor(visibleSlides)

    return (
        <Container id="top-offers">
            <TitleContainer>
                <Title>{topOfferListingsSection.heading}</Title>
                <Subtitle>{topOfferListingsSection.subheading}</Subtitle>
            </TitleContainer>
            <SliderContainer>
                <StyledCarouselProvider
                    totalSlides={topOfferListings.length}
                    visibleSlides={visibleSlides}
                    naturalSlideWidth={1}
                    naturalSlideHeight={1}
                    isIntrinsicHeight
                    lockOnWindowScroll
                    dragStep={dragStep}
                    step={dragStep}
                >
                    <StyledSlider $transitionTime={0.2}>
                        {topOfferListings.map((recommendedObject, index) => (
                            <Slide index={recommendedObject.id} key={`${index}_${recommendedObject.id}`}>
                                <GridCard
                                    key={recommendedObject.id}
                                    listingObject={recommendedObject}
                                    requestUrl={url}
                                    sitePathname={sitePathname}
                                    pageName={pageTypeEventCategories.REGION_LANDING_PAGE}
                                    sectionName={cardEventCategories.sections.TOP_OFFERS}
                                    breadcrumbModel={breadcrumbModel}
                                    offerModel={offerModel}
                                    suitablesModel={suitablesModel}
                                />
                            </Slide>
                        ))}
                    </StyledSlider>
                </StyledCarouselProvider>
            </SliderContainer>
            {topOfferListingsSection.cta?.url && (
                <CtaContainer>
                    <StyledGhostButton onClick={() => _handleViewAllAccommodationsClick()} borderRadius="1rem">
                        <CtaButtonText>{t('seeAll')}</CtaButtonText>
                    </StyledGhostButton>
                </CtaContainer>
            )}
        </Container>
    )
}

export default memo(TopOffersSection)
